import { ComponentProps, useCallback } from 'react';

export type FormProps = Omit<ComponentProps<'form'>, 'onSubmit' | 'noValidate'> & {
  onSubmit: (values: FormData) => void;
};

export function Form({ onSubmit, ...props }: FormProps) {
  const handleSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      const formData = new FormData(event.currentTarget);
      onSubmit(formData);

      return false;
    },
    [onSubmit],
  );

  return <form {...props} onSubmit={handleSubmit} noValidate />;
}
